import type { LevelDef } from '../level.ts';

// The classic crossing pair, ported from the v10 prototype.
export const prague: LevelDef = {
  id: 'prague', city: 'prague', country: 'czechia',
  blurb: 'red rooftops, two crossing strips, a gentle start',
  baseline: 85, scoreMul: 1,
  capBase: 3, capDiv: 4, capMax: 6,
  spawnLead: [5, 11], minSpawnGap: 1.6, tempo: 1,
  mix: [['light', 0.40], ['medium', 0.38], ['heavy', 0.22]],
  layout: {
    runways: [
      { x1: -0.45, y1: -0.10, x2: 0.55, y2: -0.10 },
      { x1: -0.30, y1: 0.52, x2: 0.28, y2: -0.30 },
    ],
    pads: [],
  },
  palette: { bg: '#f8f7f2', field: '#efede4', deep: '#e8e6da' },
  decor: ['roofs', 'spire'],
  // g#4 major pentatonic, bells in a medium room; every knob here was set by ear on 2026-09-05
  music: { root: 68, mode: 'major pentatonic', bpm: 62, wind: 0.4, verb: 1.05, bright: 3000, pad: 0.005, pulse: 1.1, sparks: 0.4, drone: 0.065, droneSwell: 0.4 },
};
